import { Box, Grid } from "@mui/material";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import { useState, useEffect } from "react";
import { nurseService } from "src/api/nurse/nurseService";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";

interface AddPlanModalProps {
  selectedGuideId: number | null;
  selectedPlanId?: number;
  onSuccess?: () => void;
  selectedGuideName?: string;
}

interface PlanType {
  id: number;
  name: string;
  target: string;
  is_active: string;
}

function AddPlanModal({
  selectedGuideId,
  selectedPlanId,
  onSuccess,
  selectedGuideName,
}: AddPlanModalProps) {
  console.log(selectedGuideName);
  const { t } = useTranslate();

  const [name, setName] = useState("");
  const [target, setTarget] = useState("");
  const [is_active, setIsActive] = useState(true);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastType, setToastType] = useState<"success" | "error">("success");
  const [toastTitle, setToastTitle] = useState("");
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    const fetchPlan = async () => {
      if (!selectedGuideId || !selectedPlanId) {
        setName("");
        setTarget("");
        setIsActive(true); // yeni eklemede aktif true olsun
        return;
      }

      try {
        const response: any = await nurseService.nurseCare.getAllNurseCarePlansByNcgId({
          ncgId: selectedGuideId,
        });
        const allPlans = response.data || [];
        const found = allPlans.find((plan: any) => plan.id === selectedPlanId);
        console.log(found)
        if (found) {
          setName(found.name || "");
          setTarget(found.target || "");
          setIsActive(found.is_active ==="1" ? true : false);
        }
      } catch (err) {
        console.error("Plan bilgisi alınamadı", err);
      }
    };

    fetchPlan();
  }, [selectedGuideId, selectedPlanId]);

  return (
    <Box sx={{ p: 1 }}>
      <Grid sx={{ p: 2, borderBottom: "1px solid black"}}>
        <ByzNurseSaveButton
          onClick={async () => {
            if (!selectedGuideId) return;

            try {
              let response: any;
              if (typeof selectedPlanId === "number" && selectedPlanId > 0) {
                response = await nurseService.nurseCarePlan.update(
                  { id: selectedPlanId },
                  {
                    ncpname: name,
                    ncptarget: target,
                    isactive: is_active ? "1" : "0",
                  }
                );
              } else {
                response = await nurseService.nurseCarePlan.create({
                  ncgid: selectedGuideId,
                  ncpname: name,
                  ncptarget: target,
                  isactive: is_active ? "1" : "0",
                });
              }
              
              const isSuccess = response?.issuccess !== false;
              
              if (isSuccess) {
                onSuccess?.();
              } else {
                setToastType("error");
                setToastTitle(t("toast.error-title"));
                setToastMessage(response?.message || t("toast.error-content"));
                setToastOpen(true);
              }
            } catch (error) {
              setToastType("error");
              setToastTitle(t("toast.error-title"));
              setToastMessage(t("toast.error-content"));
              setToastOpen(true);
            }
          }}
        />
      </Grid>

      <Grid container columnSpacing={2} alignItems="stretch" sx={{ borderBottom: "1px solid #E0E0E0", background: "#F4F7FE", py:".6rem" }}>
        <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
          <ByzMuiTypography>{t("nurse.care-plans.selected-guide")}</ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMuiTextField
            label={t("nurse.care-plans.selected-guide")}
            value={selectedGuideName}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>
      </Grid>

      <Grid container columnSpacing={2} alignItems="stretch" sx={{ borderBottom: "1px solid #E0E0E0", py:".5rem" }}>
        <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
          <ByzMuiTypography>{t("nurse.care-plans.plan-name")}</ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMuiTextField
            label={t("nurse.care-plans.plan-name")}
            onChange={(e) => setName(e.target.value)}
            value={name}
            fullWidth
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="stretch" sx={{ borderBottom: "1px solid #E0E0E0" , py:".5rem"}}>
        <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
          <ByzMuiTypography>{t("nurse.care-plans.target")}</ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMuiTextField
            label={t("nurse.care-plans.target")}
            onChange={(e) => setTarget(e.target.value)}
            value={target}
            fullWidth
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ borderBottom: "1px solid #E0E0E0", py:".5rem" }}>
        <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
          <ByzMuiTypography>{t("active")}</ByzMuiTypography>
        </Grid>
        <Grid item xs={8} sx={{ display: "flex", alignItems: "center", p: 2, mt: 1 }}>
          <ByzMuiCheckBox
            checked={is_active}
            onChange={(e) => setIsActive(e.target.checked)}
          />
        </Grid>
      </Grid>
      <ByzMuiSnackBar
        open={toastOpen}
        type={toastType}
        title={toastTitle}
        message={toastMessage}
        onClose={() => setToastOpen(false)}
      />
    </Box>
  );
}
export default AddPlanModal;

